import React, { useEffect, useState } from "react";
import { Modal } from "rsuite";
import { FaFilePdf } from "react-icons/fa6";

import { PDFViewer } from "@react-pdf/renderer";
import PdfTimeSheet from "../../../../components/pdfTimeSheet/PdfTimeSheet";

const ModalDetailPdf: React.FC<any> = ({
  openPdfViewerModal,
  setPdfViewerModal,
  details,
}) => {
  const [detail, setDetail] = useState<any>(details);

  useEffect(() => {
    setDetail(details);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detail, openPdfViewerModal]);

  const handleClose = () => {
    setPdfViewerModal(false);
  };

  return (
    <>
      <Modal open={openPdfViewerModal} size={"lg"} onClose={handleClose}>
        <Modal.Header>
          <Modal.Title>
            <div className="flex items-center gap-2.5">
              <span className="dv-aura flex h-9 w-9 items-center justify-center rounded-xl bg-dv-gradient text-white shadow-dv-glow">
                <FaFilePdf className="h-4 w-4" aria-hidden="true" />
              </span>
              <span className="text-lg font-bold text-navy-700 dark:text-white">
                Relatório PDF
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "780px" }}>
          <PDFViewer
            width="100%"
            height="100%"
            showToolbar
            className="table m-0"
          >
            <PdfTimeSheet detail={details} />
          </PDFViewer>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ModalDetailPdf;
